import { useUserDestroyMutation } from '~/generated/graphql';

export function useRemoveUser() {
  const [removeUser, { loading }] = useUserDestroyMutation();

  return {
    removeUser,
    loading,
  };
}
